(function () {
  var STORAGE_KEY = 'ornix_rv_products';
  var MAX_ITEMS = 20;
  var CARD_KEY_PFX = 'ornix_rv_card_';

  var sectionEl = document.querySelector('.rv-section');
  if (!sectionEl) return;

  var sectionId = sectionEl.dataset.sectionId;
  var perView = parseInt(sectionEl.dataset.perView || '4', 10);
  var currentHandle = sectionEl.dataset.currentHandle || '';

  if (currentHandle) {
    var cardStoreEl = document.getElementById('rv-card-store-' + sectionId);
    if (cardStoreEl) {
      try {
        localStorage.setItem(CARD_KEY_PFX + currentHandle, cardStoreEl.innerHTML);
        var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        stored = stored.filter(function (h) { return h !== currentHandle; });
        stored.unshift(currentHandle);
        if (stored.length > MAX_ITEMS) stored = stored.slice(0, MAX_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
      } catch (e) {}
    }
  }

  var handles = [];
  try {
    handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (currentHandle) {
      handles = handles.filter(function (h) { return h !== currentHandle; });
    }
  } catch (e) {}

  if (!handles.length) {
    sectionEl.style.display = 'none';
    return;
  }

  var wrapper = document.getElementById('rv-swiper-wrapper-' + sectionId);
  var insertedCount = 0;

  handles.forEach(function (handle) {
    var cardHTML = '';
    try { cardHTML = localStorage.getItem(CARD_KEY_PFX + handle) || ''; } catch (e) {}
    if (!cardHTML) return;

    var temp = document.createElement('div');
    temp.innerHTML = cardHTML;
    var slide = temp.querySelector('[data-rv-handle="' + handle + '"]');
    if (slide) {
      wrapper.appendChild(slide);
      insertedCount++;
    }
  });

  if (!insertedCount) {
    sectionEl.style.display = 'none';
    return;
  }

  var prevBtn = sectionEl.querySelector('.rv-btn--prev');
  var nextBtn = sectionEl.querySelector('.rv-btn--next');
  if (insertedCount <= perView) {
    if (prevBtn) prevBtn.classList.add('rv-btn--hidden');
    if (nextBtn) nextBtn.classList.add('rv-btn--hidden');
  }

  function initSwiper() {
    if (typeof Swiper === 'undefined') return;
    new Swiper(sectionEl.querySelector('.rv-swiper'), {
      slidesPerView: 1,
      spaceBetween: 30,
      grabCursor: true,
      navigation: {
        prevEl: sectionEl.querySelector('.rv-btn--prev'),
        nextEl: sectionEl.querySelector('.rv-btn--next'),
      },
      breakpoints: {
        320: { slidesPerView: 1 },
        480: { slidesPerView: 2 },
        750: { slidesPerView: 3 },
        990: { slidesPerView: perView }
      }
    });
  }

  function reinitCards() {
    wrapper.querySelectorAll('[data-swatch-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.product-card');
        if (!card) return;

        card.querySelectorAll('[data-swatch-value]').forEach(function (b) {
          b.classList.remove('product-card__swatch--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('product-card__swatch--active');
        btn.setAttribute('aria-pressed', 'true');

        var swatchImg = btn.dataset.swatchImage;
        if (swatchImg) {
          var swiperEl = card.querySelector('[data-product-swiper]');
          if (swiperEl && swiperEl.swiper) {
            var firstSlideImg = swiperEl.querySelector('.swiper-slide:first-child img');
            if (firstSlideImg) firstSlideImg.src = swatchImg;
            swiperEl.swiper.slideTo(0, 0);
          } else {
            var img = card.querySelector('.product-card__img--primary, .product-card__img');
            if (img) img.src = swatchImg;
          }
        }

        var saleEl    = card.querySelector('[data-product-price-sale]');
        var compareEl = card.querySelector('[data-product-price-compare]');
        var regularEl = card.querySelector('[data-product-price-regular]');
        var price      = btn.dataset.price;
        var compare    = btn.dataset.compareAtPrice;
        var priceRaw   = parseInt(btn.dataset.priceRaw || '0', 10);
        var compareRaw = parseInt(btn.dataset.compareAtPriceRaw || '0', 10);

        if (compareRaw > priceRaw) {
          if (saleEl)    { saleEl.textContent = price; saleEl.style.display = ''; }
          if (compareEl) { compareEl.textContent = compare; compareEl.style.display = ''; }
          if (regularEl) regularEl.style.display = 'none';
        } else {
          if (regularEl) { regularEl.textContent = price; regularEl.style.display = ''; }
          if (saleEl)    saleEl.style.display = 'none';
          if (compareEl) compareEl.style.display = 'none';
        }

        var atcBtn = card.querySelector('[data-atc-btn]');
        if (atcBtn) {
          atcBtn.dataset.variantId = btn.dataset.variantId;
          atcBtn.dataset.compareAtPrice = btn.dataset.compareAtPriceRaw;
        }
      });
    });
  }

  function reinitProductCardSwipers() {
    wrapper.querySelectorAll('[data-product-swiper]').forEach(function (el) {
      if (el.swiper) return;

      var paginationEl = el.querySelector('[data-swiper-pagination]');

      new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true,
        } : false,
      });
    });
  }

  if (document.readyState === 'complete') {
    initSwiper();
    reinitCards();
    reinitProductCardSwipers();
  } else {
    window.addEventListener('load', function () {
      initSwiper();
      reinitCards();
      reinitProductCardSwipers();
    });
  }

})();